export default __webpack_public_path__ + "static/image1-a38b343ce03a545390bdd76d2c21a9fd.gif";